<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.524 15.358c-.735.761-1.617 1.142-2.649 1.142-1.031 0-1.914-.38-2.648-1.142-.735-.761-1.102-1.677-1.102-2.747V6.39c0-1.07.367-1.985 1.102-2.747.734-.761 1.617-1.142 2.648-1.142 1.031 0 1.914.381 2.649 1.142.734.762 1.101 1.678 1.101 2.747v6.222c0 1.07-.367 1.986-1.101 2.747ZM17.592 10c.2 0 .375.077.521.232.147.155.22.338.22.55v1.562c0 1.798-.569 3.363-1.707 4.693-1.138 1.33-2.544 2.094-4.219 2.289v1.611h2.963c.2 0 .374.078.52.232a.77.77 0 0 1 .22.55.771.771 0 0 1-.22.549.694.694 0 0 1-.52.232H7.963a.695.695 0 0 1-.52-.232.772.772 0 0 1-.22-.55c0-.211.073-.394.22-.549a.694.694 0 0 1 .52-.232h2.963v-1.611c-1.675-.195-3.08-.958-4.219-2.289C5.57 15.707 5 14.142 5 12.344V10.78c0-.211.073-.394.22-.549A.694.694 0 0 1 5.74 10c.202 0 .375.077.522.232.146.155.22.338.22.55v1.562c0 1.505.507 2.793 1.521 3.863 1.015 1.07 2.236 1.605 3.664 1.605 1.427 0 2.648-.535 3.663-1.605 1.014-1.07 1.522-2.358 1.522-3.863V10.78c0-.211.073-.394.22-.549a.695.695 0 0 1 .52-.232Z" fill="url(#paint0_linear_70_1983)" />
    <defs>
      <linearGradient
        id="paint0_linear_70_1983"
        x1="-4.329"
        y1="18.37"
        x2="17.123"
        y2="30.768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F8B700" />
        <stop offset=".51" stop-color="#F87900" />
        <stop offset="1" stop-color="#AE35DD" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {}
</script>
